import React from 'react';
import I18n from 'i18n-js';
import { RCButton, RCIcon, RCText } from '@reverbdotcom/cadence/components';
import {
  ArrowLeftIcon,
  BankIcon,
  WarningCircleIcon,
} from '@reverbdotcom/cadence/icons/react';
import { SvgMapPin, SvgUsers } from './action_icons';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { NotificationsCenterQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { clickedNotificationEvent } from './notification_event_props';

type NotificationAction = NotificationsCenterQuery['notificationActions']['actions'][number];

const ACTION_ICONS: Record<string, JSX.Element> = {
  bank: <BankIcon />,
  'map-pin': <SvgMapPin />,
  users: <SvgUsers />,
  'warning-circle': <WarningCircleIcon />,
};

function actionIcon(iconName: string): JSX.Element {
  return ACTION_ICONS[iconName] ?? <WarningCircleIcon />;
}

interface IProps {
  actions: NotificationAction[];
  onBack: () => void;
}

export default function ActionsRollupView({ actions, onBack }: IProps) {
  return (
    <div className="notifications-center__rollup">
      <div className="notifications-center__rollup__header">
        <RCButton
          variant="transparent"
          size="small"
          iconOnly={<ArrowLeftIcon />}
          iconLabel={I18n.t('discovery.notificationsCenter.actions.back')}
          onClick={onBack}
        />
      </div>

      <ul className="notifications-center__rollup__list">
        {actions.map(action => (
          <li key={action.key}>
            <ActionCard action={action} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ActionCard({ action }: { action: NotificationAction }) {
  return (
    <CoreLink
      to={action.href}
      className="notifications-center__action-card"
      clickEvent={clickedNotificationEvent(action.eventTracking)}
    >
      <span className="notifications-center__action-card__icon">
        <RCIcon icon={actionIcon(action.iconName)} size={7} />
      </span>
      <span className="notifications-center__action-card__text">
        <RCText.Utility size="350" weight="semibold" htmlTag="span">
          {action.title}
        </RCText.Utility>
        <RCText.Default size="350" htmlTag="span">
          {action.description}
        </RCText.Default>
      </span>
    </CoreLink>
  );
}
